interface Props {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, pageSize, total, onChange }: Props) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <div className="pagination">
      <span className="muted">{total.toLocaleString('pt-BR')} pedidos</span>
      <button disabled={page <= 1} onClick={() => onChange(page - 1)}>‹</button>
      <span>{page} / {pages}</span>
      <button disabled={page >= pages} onClick={() => onChange(page + 1)}>›</button>
    </div>
  );
}
